import { useEffect, useState } from 'react';
import { useAuth } from '../../Context/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LockClosedIcon, MailIcon, RefreshIcon } from '@heroicons/react/outline';
import { seedVillageData } from '../../utils/seeder';

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, currentUser } = useAuth();
  const navigate = useNavigate();
  const { slug } = useParams();

  // Reactive redirect: if already logged in, move to dashboard
  useEffect(() => {
    if (currentUser) {
      navigate(`/${slug}/cms/dashboard`);
    }
  }, [currentUser, navigate, slug]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Login Berhasil!");
      navigate(`/${slug}/cms/dashboard`);
    } catch (error) {
      console.error(error);
      toast.error("Gagal Login: Email atau Password salah.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-3xl shadow-xl shadow-gray-200/50 border border-gray-100">
        <div>
          <div className="mx-auto h-16 w-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6">
            <LockClosedIcon className="h-8 w-8 text-primary" />
          </div>
          <h2 className="text-center text-3xl font-extrabold text-gray-900 tracking-tight">
            CMS Gampong
          </h2>
          <p className="mt-2 text-center text-sm text-gray-500">
            Silakan login untuk mengelola konten gampong
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleLogin}>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-bold text-gray-700 mb-1 block">Email Address</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <MailIcon className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full pl-10 pr-3 py-3 border border-gray-100 bg-gray-50/50 rounded-2xl text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  placeholder="admin@gampong.id"
                />
              </div>
            </div>
            <div>
              <label className="text-sm font-bold text-gray-700 mb-1 block">Password</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <LockClosedIcon className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full pl-10 pr-3 py-3 border border-gray-100 bg-gray-50/50 rounded-2xl text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  placeholder="••••••••"
                />
              </div>
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-3.5 px-4 border border-transparent text-sm font-bold rounded-2xl text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all shadow-lg shadow-primary/20 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              ) : (
                "Masuk ke Dashboard"
              )}
            </button>
          </div>

          {/* <div className="pt-4 border-t border-gray-100 mt-6">
            <p className="text-[11px] text-center text-gray-400 mb-3 px-4 leading-relaxed">
              Jika ini adalah instalasi baru, gunakan tombol di bawah untuk membuat data desa & akun admin default.
            </p>
            <button
              type="button"
              onClick={seedVillageData}
              className="flex items-center justify-center w-full py-3 px-4 border border-gray-200 text-xs font-bold rounded-2xl text-gray-500 bg-white hover:bg-gray-50 transition-all"
            >
              <RefreshIcon className="w-4 h-4 mr-2 text-gray-400" />
              Inisialisasi Akun & Data Desa
            </button>
            <p className="mt-2 text-[10px] text-center text-gray-300 italic">
              Default: superadmin@gampong.id / 123456
            </p>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
